export const backendBaseURL = process.env.VUE_APP_WEBSITE_BASE_URL;
export const quotationAPIBaseURL = backendBaseURL + 'quotations/';
